// removed by extract-text-webpack-plugin
module.exports = {"sideBarLogoBg":"#10104e","menuBg":"#10104e","menuHover":"#685af4","menuText":"#fff","menuActiveText":"#fff","subMenuBg":"#10104e","subMenuHover":"#685af4","subMenuActiveText":"#fff","sideBarWidth":"210px"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = yh13
// module chunks = 10